{
  "name": "@llmist/cli",
  "version": "18.4.0",
  "description": "CLI for llmist - run LLM agents from the command line",
  "type": "module",
  "main": "dist/cli.js",
  "types": "dist/cli.d.ts",
  "bin": {
    "llmist": "dist/cli.js"
  },
  "exports": {
    ".": {
      "import": {
        "types": "./dist/cli.d.ts",
        "default": "./dist/cli.js"
      }
    },
    "./gadgets": {
      "import": {
        "types": "./dist/index.d.ts",
        "default": "./dist/index.js"
      }
    }
  },
  "scripts": {
    "build": "tsup",
    "typecheck": "tsc --noEmit",
    "clean": "rimraf dist",
    "postinstall": "node scripts/postinstall.js",
    "dev": "npx --silent tsx src/cli.ts"
  },
  "homepage": "https://llmist.dev",
  "repository": {
    "type": "git",
    "url": "https://github.com/zbigniewsobiecki/llmist.git",
    "directory": "packages/cli"
  },
  "publishConfig": {
    "access": "public"
  },
  "files": [
    "dist",
    "scripts"
  ],
  "keywords": [
    "llmist",
    "cli",
    "llm",
    "agents",
    "terminal",
    "tui"
  ],
  "author": "Zbigniew Sobiecki <zbigniew@sobiecki.name>",
  "license": "MIT",
  "sideEffects": false,
  "engines": {
    "node": ">=22.0.0"
  },
  "dependencies": {
    "llmist": "^18.4.0",
    "@unblessed/node": "^1.0.0-alpha.23",
    "diff-match-patch": "^1.0.5",
    "chalk": "^5.6.2",
    "commander": "^12.1.0",
    "diff": "^8.0.2",
    "eta": "^4.4.1",
    "jiti": "^2.6.1",
    "js-toml": "^1.1.0",
    "js-yaml": "^4.1.0",
    "marked": "^15.0.12",
    "marked-terminal": "^7.3.0",
    "zod": "^4.1.12"
  },
  "devDependencies": {
    "@llmist/testing": "^18.4.0",
    "@types/diff": "^8.0.0",
    "@types/diff-match-patch": "^1.0.36",
    "@types/js-yaml": "^4.0.9",
    "@types/marked-terminal": "^6.1.1",
    "@types/node": "^20.12.7",
    "rimraf": "^5.0.5",
    "tsup": "^8.3.5",
    "typescript": "^5.4.5"
  }
}
